import CustomDropdown from './customDropdown';

class ECTItem extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { id, title, date, imageUrl, eventDate, eventVenue, eventAvailableSeat, className, trainingDropdown, typeBlock, dateValidity, index} = this.props;
    return (
        <div className={`${className || ''} ect-item-wrapper`}>
            <div className="img-item-wrapper p-relative">
                <span className="badge block-type">{typeBlock}</span>
                <img src={imageUrl} onError={(e) => {e.target.onerror = null; e.target.src = default_img; }} className="img-fluid" alt="Event" />
            </div>
            <div className="ect-item-metadata">
                <h1>{title}</h1>
                {date &&
                  <p>{date}</p>
                }
                
                {dateValidity == '0' && eventDate && 
                  <div class="mb-2 icon-teacher-expiry d-flex align-items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-clock"><path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"></path><path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"></path></svg>
                    <p class="p-0 m-0 d-inline-flex gap-1 mk-flex-one">{eventDate}</p>
                  </div>
                }
                {dateValidity == '0' && eventVenue &&
                  <div class="mb-2 icon-teacher-expiry d-flex align-items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16"><path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 018 14.58a31.481 31.481 0 01-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0110 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 002 6c0 4.314 6 10 6 10z"></path><path d="M8 8a2 2 0 110-4 2 2 0 010 4zm0 1a3 3 0 100-6 3 3 0 000 6z"></path></svg>
                    <p class="p-0 m-0 d-inline-flex gap-1 mk-flex-one">{eventVenue}</p>
                  </div>
                }
                {trainingDropdown &&
                  <CustomDropdown label="Select Training Course" options={trainingDropdown} courseId={id} index={index} />
                }
                {dateValidity == '0' && eventAvailableSeat &&
                  <span class="badge mk-badge-expired">{eventAvailableSeat} seats left</span>
                  // <span bg="primary" class="badge">Event Completed</span>
                }
                {dateValidity == '1' && typeBlock != 'Training' ?
                  <span class="badge mk-badge-expired">Expired</span> : ''
                }
            </div>
        </div>
    );
  }
}

export default ECTItem;


